import React from "react";
import GreenIcon from "./../../../images/automate_kpi/light_green_circle.png";
import PurpleIcon from "./../../../images/automate_kpi/dark_purple_circle.png";
import DoughNutChart from "./../DoughNutChart";
import PropTypes from "prop-types";
import { Alert } from "react-bootstrap";
import MiniLoader from "../../../utilityComponents/MiniLoader";

function KpiSummaryLevelThreeKpiCard(props) {
    return (
        <div className="col-lg-4">
            <div
                className="card"
                style={{
                    border: "solid #757AF7",
                    borderRadius: "0%",
                    height: "100%",
                }}
            >
                <div
                    className="card-header"
                    style={{
                        backgroundColor: "#757AF7",
                        color: "#FFFFFF",
                        fontWeight: "bold",
                        borderRadius: "0%",
                    }}
                >
                    {props.kpiName}
                </div>
                {props.loading ? (
                    <MiniLoader />
                ) : props.error ? (
                    <Alert key="danger" variant="danger">
                        {props.error}
                    </Alert>
                ) : props.kpiStatusData === undefined ? (
                    <Alert key="info" variant="info">
                        Please select cad topology !
                    </Alert>
                ) : Object.keys(props.kpiStatusData).length === 0 ? (
                    <Alert key="info" variant="info">
                        No records found for this cad topology !
                    </Alert>
                ) : (
                    <div>
                        <div className="card-body" style={{ padding: "5%" }}>
                            <div className="card-title" style={{ color: "#464646" }}>
                                <div>
                                    <img
                                        src={GreenIcon}
                                        alt="greenIcon"
                                        style={{ padding: "0% 3%" }}
                                    />
                                    <p style={{ display: "inline-block", fontSize: "0.8rem" }}>
                                        Good scenarios
                                    </p>
                                    <img
                                        src={PurpleIcon}
                                        alt="pupleIcon"
                                        style={{ padding: "0% 3%" }}
                                    />
                                    <p style={{ display: "inline-block", fontSize: "0.8rem" }}>
                                        Not-Good scenarios
                                    </p>
                                </div>
                            </div>
                            <div>
                                <DoughNutChart
                                    data={[
                                        props.kpiStatusData.info.pass,
                                        props.kpiStatusData.info.fail,
                                    ]}
                                    labels={["Good Scenarios", "Not Good Scenarios"]}
                                ></DoughNutChart>
                                <div
                                    className="row mytab"
                                    id="hover"
                                    style={{
                                        backgroundColor: "#E2E3FF",
                                        fontSize: "1rem",
                                        color: "#464646",
                                        margin: "2% 0%",
                                        padding: "1%",
                                    }}
                                >
                                    <div
                                        className="col-md-12 btn"
                                        id="hover"
                                        style={{
                                            color: "#464646",
                                            backgroundColor: "#E2E3FF",
                                        }}
                                    >
                                        <div
                                            className="col-md-6 text-left"
                                            style={{
                                                padding: "0px",
                                                color: "#464646",
                                                display: "inline-block",
                                            }}
                                        >
                                            Good Scenario&apos;s
                                        </div>
                                        <div
                                            className="col-md-6 text-right"
                                            style={{
                                                padding: "0px",
                                                color: "#464646",
                                                display: "inline-block",
                                            }}
                                        >
                                            {props.kpiStatusData.info.pass}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="row mytab"
                                    id="hover"
                                    style={{
                                        backgroundColor: "#E2E3FF",
                                        fontSize: "1rem",
                                        color: "#464646",
                                        margin: "2% 0%",
                                        padding: "1%",
                                    }}
                                >
                                    <div
                                        className="col-md-12 btn"
                                        id="hover"
                                        style={{
                                            color: "#464646",
                                            backgroundColor: "#E2E3FF",
                                        }}
                                    >
                                        <div
                                            className="col-md-6 text-left"
                                            style={{
                                                padding: "0px",
                                                color: "#464646",
                                                display: "inline-block",
                                            }}
                                        >
                                            Not Good Scenario&apos;s
                                        </div>
                                        <div
                                            className="col-md-6 text-right"
                                            style={{
                                                padding: "0px",
                                                color: "#464646",
                                                display: "inline-block",
                                            }}
                                        >
                                            {props.kpiStatusData.info.fail}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

KpiSummaryLevelThreeKpiCard.propTypes = {
    kpiStatusData: PropTypes.object,
    loading: PropTypes.bool,
    error: PropTypes.string,
    kpiName: PropTypes.string,
};

KpiSummaryLevelThreeKpiCard.defaultProps = {
    kpiStatusData: {},
};

export default KpiSummaryLevelThreeKpiCard;
